// Stable API business codes; keep the Vietnamese and English key sets identical.
export const businessErrorsVi = {
  "admin_cancellation_not_supported": "Quản trị viên chỉ có thể hủy ngoại lệ đơn tăng ca riêng.",
  "request_state_changed": "Đơn đã thay đổi. Vui lòng tải lại trước khi tiếp tục.",
  "amortization_source_locked": "Phiếu đã có phân bổ chi phí; cần xử lý phân bổ liên quan trước khi đổi mã chi phí.",
  "supplier_invoice_payment_owner_locked": "Hóa đơn đã có thanh toán; cần giữ nguyên nhà cung cấp để bảo toàn lịch sử thanh toán.",
  "invoice_payment_currency_locked": "Hóa đơn đã có thu tiền; cần giữ nguyên loại tiền để bảo toàn lịch sử thanh toán.",
  "supplier_invoice_payment_currency_locked": "Hóa đơn đã có thanh toán; cần giữ nguyên loại tiền để bảo toàn lịch sử thanh toán.",
  "trip_distance_required": "Vui lòng nhập quãng đường công tác lớn hơn 0 km cho từng ngày.",
  "annual_leave_consecutive_limit": "Nghỉ phép năm liên tiếp trong tháng không được vượt quá 3 ngày làm việc, tính cả các đề nghị đang chờ duyệt và đã duyệt.",
  "annual_leave_insufficient_balance": "Không đủ ngày phép để nghỉ có lương: cần {required} ngày (tính cả đơn có lương đang chờ duyệt), sổ phép đến {date} còn {balance} ngày. Hãy chọn nghỉ không lương hoặc rút ngắn đơn.",
  "leave_period_invalid": "Chỉ được đăng ký nghỉ sáng (08:00–12:15), nghỉ chiều (13:15–17:00) hoặc nghỉ cả ngày.",
  "leave_session_limit": "Kế hoạch nghỉ có tối đa 120 buổi.",
  "leave_session_duplicate_date": "Mỗi ngày trong kế hoạch nghỉ chỉ có một buổi.",
  "leave_session_span": "Kế hoạch nghỉ phải nằm trong một năm.",
  "leave_plan_attachment_required": "Kế hoạch nghỉ định kỳ phải đính kèm lịch học trước khi gửi duyệt.",
  "annual_leave_ledger_not_opened": "Chưa mở sổ phép năm nên chưa thể nghỉ có lương. Liên hệ nhân sự để mở sổ hoặc chọn nghỉ không lương.",
  "enrollment_not_deletable": "Chỉ có thể xoá đăng ký nháp chưa gắn với quy trình duyệt.",
  "invalid_status": "Trạng thái hiện tại không cho phép thực hiện thao tác này.",
  "quotation_project_mismatch": "Báo giá được chọn không thuộc dự án của P/O.",
  "reference_service_unavailable": "Không kiểm tra được dữ liệu tham chiếu ở dịch vụ khác. Vui lòng thử lại.",
  "supplier_invoice_overpayment": "Số tiền chi vượt số còn phải thanh toán của hóa đơn nhà cung cấp.",
  "supplier_invoice_source_locked": "Hóa đơn đang gắn với phiếu chi. Không thể thay đổi các thông tin nguồn đã liên kết.",
  "supplier_payment_source_locked": "Khoản thanh toán được tạo từ phiếu chi đã trả, không thể xoá riêng khỏi hóa đơn.",
  "cash_negative_confirmation_required": "Số dư sẽ âm. Vui lòng xác nhận và nhập lý do trước khi tiếp tục.",
  "cash_opening_exists": "Số dư đầu kỳ đã tồn tại cho quỹ và loại tiền này.",
  "cash_opening_future": "Ngày số dư đầu kỳ không được nằm trong tương lai.",
  "password_reset_invalid": "Liên kết đặt lại mật khẩu không hợp lệ hoặc đã hết hạn. Vui lòng yêu cầu liên kết mới.",
  "password_policy_failed": "Mật khẩu phải có từ 12 đến 200 ký tự.",
  "password_reset_rate_limited": "Đã thử quá nhiều lần. Vui lòng chờ rồi thử lại.",
  "payroll_payment_ineligible": "Khoản chi lương chưa đủ điều kiện thanh toán.",

  "amortization_code_exists": "Mã khoản phân bổ đã tồn tại.",
  "expense_category_unknown": "Không tìm thấy loại chi phí đã chọn.",
  "invoice_slot_out_of_order": "Vui lòng xuất hóa đơn đúng thứ tự các đợt.",
  "supplier_invoice_exists": "Hóa đơn nhà cung cấp đã tồn tại.",
  "purchase_order_exceeds_request": "Số lượng đặt mua vượt đề nghị mua hàng.",
  "authorization_validation_unavailable": "Tạm thời không xác minh được quyền truy cập. Vui lòng thử lại.",  "active_request_overlap": "Khoảng thời gian bị trùng với đề nghị đang có hiệu lực.",
  "advance_already_settled": "Khoản tạm ứng đã được quyết toán.",
  "advance_not_found": "Không tìm thấy khoản tạm ứng.",
  "advance_not_owned": "Khoản tạm ứng không thuộc người đề nghị.",
  "advance_not_paid": "Khoản tạm ứng chưa được chi tiền.",
  "advance_reference_required": "Vui lòng chọn khoản tạm ứng cần quyết toán.",
  "allocation_outside_request": "Phân bổ nằm ngoài thời gian đề nghị.",
  "allocation_outside_travel": "Phân bổ nằm ngoài thời gian công tác.",
  "allocation_overlap": "Các khoảng phân bổ bị trùng nhau.",
  "allocation_part_mismatch": "Phân bổ không khớp phần đề nghị.",
  "allocation_participant_missing": "Chưa chọn người tham gia cho phân bổ.",
  "allocation_project_mismatch": "Dự án của phân bổ không khớp đề nghị.",
  "allocation_request_mismatch": "Phân bổ không thuộc đề nghị này.",
  "amortization_below_allocated": "Giá trị phân bổ không được thấp hơn số đã phân bổ.",
  "amortization_currency_locked": "Không thể đổi loại tiền sau khi đã phân bổ.",
  "amortization_effective_month": "Tháng bắt đầu phân bổ không hợp lệ.",
  "amortization_no_remaining_period": "Không còn kỳ để phân bổ giá trị còn lại.",
  "amortization_revision_order": "Thứ tự phiên bản phân bổ không hợp lệ.",
  "approval_audit_missing": "Thiếu thông tin kiểm chứng phê duyệt.",
  "approved_part_locked": "Phần đề nghị đã duyệt không thể sửa trực tiếp.",
  "assessment_header_immutable": "Không thể thay đổi thông tin định danh của đánh giá.",
  "assessment_not_editable": "Đánh giá không còn ở trạng thái cho phép sửa.",
  "bank_csv_empty": "Tệp sao kê trống.",
  "bank_csv_header_not_found": "Không tìm thấy dòng tiêu đề sao kê hợp lệ.",
  "bank_csv_invalid_quotes": "Dấu ngoặc kép trong tệp sao kê không hợp lệ.",
  "bank_csv_no_rows": "Sao kê không có dòng giao dịch.",
  "bank_csv_too_large": "Tệp sao kê vượt giới hạn cho phép.",
  "bank_line_is_credit": "Giao dịch này là khoản thu, không thể đối soát với khoản chi.",
  "bank_line_is_debit": "Giao dịch này là khoản chi, không thể đối soát với khoản thu.",
  "bank_match_not_paid": "Chứng từ chưa được ghi nhận thanh toán.",
  "bank_match_taken": "Giao dịch đã được đối soát với chứng từ khác.",
  "bank_source_owner_unresolved": "Không xác định được dự án của chứng từ đối soát. Vui lòng kiểm tra chứng từ nguồn.",
  "bank_line_allocation_locked": "Dòng đã khớp chứng từ nên dự án và mã chi phí lấy theo chứng từ đó.",
  "landed_cost_category_invalid": "Chỉ dòng thuế, phí nhập khẩu mới phân bổ được vào giá vật tư.",
  "landed_cost_items_required": "Chọn ít nhất một phiếu nhập để phân bổ.",
  "landed_cost_total_mismatch": "Tổng phân bổ phải bằng tiền của dòng phí.",
  "landed_cost_receipt_invalid": "Phiếu nhập không thuộc lô hàng này hoặc chưa được duyệt.",
  "landed_cost_not_allocated": "Dòng này chưa có phân bổ đang hiệu lực.",
  "stock_receipt_has_landed_cost": "Phiếu nhập đang có thuế phí phân bổ. Huỷ phân bổ trước khi đảo phiếu nhập.",
  "bank_line_possible_duplicate": "Sổ quỹ ngân hàng đã có bút toán ghi tay cùng ngày, cùng số tiền. Xác nhận nếu đây là khoản khác.",
  "calendar_not_editable": "Lịch làm việc không còn ở trạng thái cho phép sửa.",
  "cash_advance_limit_exceeded": "Số tiền tạm ứng vượt hạn mức cho phép.",
  "cash_entry_already_reversed": "Bút toán đã được đảo.",
  "cash_entry_is_reversal": "Không thể đảo một bút toán đảo.",
  "cash_entry_source_unresolved": "Không tìm thấy phiếu chi nguồn của bút toán này.",
  "compatibility_role_name_protected": "Tên vai trò tương thích được hệ thống bảo vệ.",
  "currency_mismatch": "Loại tiền không khớp với chứng từ liên quan.",
  "document_number_required": "Vui lòng nhập số chứng từ.",
  "document_template_invalid": "Mẫu chứng từ không hợp lệ: thiếu hoặc sai trường dữ liệu. Hãy kiểm tra mẫu trong Mẫu chứng từ.",
  "duplicate_account_group": "Nhóm tài khoản đã tồn tại.",
  "duplicate_code": "Mã đã tồn tại.",
  "duplicate_participant": "Người tham gia bị lặp trong danh sách.",
  "duplicate_request_part": "Phần đề nghị bị trùng.",
  "duplicate_role": "Vai trò đã tồn tại.",
  "duplicate_user": "Tài khoản đã tồn tại.",
  "duplicate_vehicle_code": "Mã phương tiện đã tồn tại.",
  "employee_not_found": "Không tìm thấy nhân viên.",
  "employee_profile_missing": "Tài khoản chưa có hồ sơ nhân viên.",
  "exchange_rate_snapshot_required": "Cần chốt tỷ giá cho chứng từ ngoại tệ.",
  "expense_category_exists": "Loại chi phí đã tồn tại.",
  "expense_category_invalid": "Loại chi phí không hợp lệ.",
  "group_details_required": "Vui lòng bổ sung chi tiết đề nghị nhóm.",
  "group_fields_required": "Vui lòng bổ sung thông tin bắt buộc của đề nghị nhóm.",
  "idempotency_conflict": "Mã thao tác đã được dùng với dữ liệu khác. Tải lại và thử lại.",
  "insufficient_stock": "Số lượng tồn kho không đủ.",
  "internal_service_unavailable": "Dịch vụ liên quan tạm thời không khả dụng. Vui lòng thử lại.",
  "invalid_author": "Người tạo không hợp lệ cho thao tác này.",
  "invalid_credentials": "Tên đăng nhập hoặc mật khẩu không đúng.",
  "invalid_date_range": "Khoảng ngày không hợp lệ. Vui lòng kiểm tra ngày bắt đầu và kết thúc.",
  "invalid_editor": "Bạn không có quyền sửa bản ghi này.",
  "invalid_late_arrival_time": "Thời gian đi muộn không hợp lệ.",
  "invalid_material": "Vật tư đã chọn không hợp lệ.",
  "invalid_party": "Đối tượng giao dịch không hợp lệ.",
  "invalid_project": "Dự án trên dòng hóa đơn không hợp lệ.",
  "invalid_quotation_template": "Mẫu báo giá không hợp lệ.",
  "invalid_reference_response": "Không xác minh được dữ liệu tham chiếu. Vui lòng thử lại.",
  "invalid_refresh_token": "Phiên đăng nhập không còn hợp lệ. Vui lòng đăng nhập lại.",
  "platform_account_not_linked": "Không có tài khoản CRM đang hoạt động dùng email Q One này. Liên hệ quản trị CRM.",
  "platform_delegation_failed": "Q One Platform từ chối yêu cầu ủy quyền.",
  "platform_email_required": "Tài khoản Q One không có email.",
  "platform_login_disabled": "Chưa bật đăng nhập bằng Q One.",
  "platform_token_invalid": "Mã đăng nhập Q One không hợp lệ hoặc đã hết hạn.",
  "platform_unavailable": "Tạm thời không đăng nhập được bằng Q One.",
  "invalid_replacement_invoice": "Hóa đơn thay thế không hợp lệ.",
  "invalid_request_group": "Nhóm đề nghị không hợp lệ.",
  "invalid_review_status": "Trạng thái xét duyệt không hợp lệ.",
  "invalid_state": "Trạng thái hiện tại không cho phép thao tác này.",
  "invalid_stock_count": "Thông tin kiểm kê không hợp lệ.",
  "invalid_submitter": "Người gửi không hợp lệ cho thao tác này.",
  "invalid_supplier": "Nhà cung cấp đã chọn không hợp lệ.",
  "invalid_time_zone": "Múi giờ không hợp lệ.",
  "invalid_transaction_type": "Loại giao dịch không hợp lệ.",
  "invalid_travel_form": "Hình thức công tác không hợp lệ.",
  "invalid_value": "Giá trị đã nhập không hợp lệ.",
  "invalid_workflow_actor": "Bạn không phải người được phân công xử lý bước này.",
  "invalid_workflow_response": "Phản hồi từ quy trình phê duyệt không hợp lệ.",
  "target_integration_unavailable": "Loại hồ sơ này không được cấu hình đồng bộ ở môi trường hiện tại (thường do hồ sơ được tạo từ một môi trường khác dùng chung cơ sở dữ liệu).",
  "invalid_workflow_transition": "Không thể chuyển quy trình sang trạng thái được yêu cầu.",
  "invoice_already_voided": "Hóa đơn đã được huỷ.",
  "invoice_amount_incomplete": "Giá trị các đợt hóa đơn chưa đủ theo yêu cầu.",
  "invoice_amount_missing": "Chưa có giá trị hóa đơn.",
  "invoice_number_occupied": "Khách hàng đã có hóa đơn với số này trong cùng đơn vị trực thuộc.",
  "invoice_referenced_by_stock": "Hóa đơn đang được tham chiếu bởi giao dịch kho.",
  "invoice_slot_invalid": "Đợt xuất hóa đơn không hợp lệ.",
  "invoice_slot_occupied": "Đợt này đã có hóa đơn.",
  "invoice_slots_exhausted": "Đã dùng hết các đợt xuất hóa đơn.",
  "invoice_voided": "Hóa đơn đã huỷ không thể thực hiện thao tác này.",
  "last_identity_administrator": "Phải giữ ít nhất một quản trị viên đang hoạt động.",
  "leave_classification_required": "Vui lòng chọn loại nghỉ phép.",
  "legacy_workflow_immutable": "Không thể sửa trực tiếp đề nghị thuộc quy trình cũ.",
  "material_immutable": "Không thể đổi vật tư của dòng này.",
  "material_unit_mismatch": "Đơn vị tính không khớp với vật tư.",
  "monthly_late_limit_reached": "Đã đạt giới hạn đi muộn trong tháng.",
  "new_calendar_revision_required": "Vui lòng tạo phiên bản lịch làm việc mới.",
  "open_advance_exists": "Người đề nghị còn khoản tạm ứng chưa quyết toán.",
  "overtime_minimum_not_met": "Thời lượng tăng ca chưa đạt mức tối thiểu.",
  "part_not_editable": "Phần đề nghị không còn ở trạng thái cho phép sửa.",
  "part_revision_required": "Vui lòng tạo phiên bản mới cho phần đề nghị.",
  "participant_allocation_required": "Vui lòng phân bổ công việc cho người tham gia.",
  "participant_not_found": "Không tìm thấy người tham gia đã chọn.",
  "payment_exceeds_invoice": "Số tiền thanh toán vượt giá trị còn lại của hóa đơn.",
  "payment_evidence_required": "Cần đính kèm ít nhất một báo giá, hợp đồng, chứng từ hoặc hóa đơn trước khi gửi duyệt.",
  "payment_evidence_unavailable": "Chưa kiểm tra được chứng từ đính kèm. Hãy thử lại khi dịch vụ tài liệu hoạt động.",
  "payment_reference_required": "Vui lòng chọn chứng từ thanh toán liên quan.",
  "payment_request_lines_required": "Phiếu thanh toán phải có ít nhất một dòng chi tiết.",
  "payment_request_not_deletable": "Phiếu thanh toán không còn ở trạng thái cho phép xoá.",
  "payment_request_not_editable": "Phiếu thanh toán không còn ở trạng thái cho phép sửa.",
  "payroll_already_sent": "Phiếu lương đã được gửi.",
  "payroll_checksum_mismatch": "Dữ liệu phiếu lương đã thay đổi so với bản đã chốt.",
  "payroll_delivery_unknown": "Chưa xác định được kết quả gửi phiếu lương. Kiểm tra trước khi gửi lại.",
  "payroll_employee_duplicate": "Nhân viên bị lặp trong kỳ lương.",
  "payroll_export_unavailable": "Tệp phiếu lương chưa sẵn sàng.",
  "payroll_incomplete": "Dữ liệu tính lương chưa đầy đủ.",
  "payroll_locked": "Kỳ lương đã khoá.",
  "payroll_source_stale": "Dữ liệu công hoặc đơn đã duyệt thay đổi sau lần bảng lương lấy dữ liệu. Cập nhật dữ liệu rồi tính lại.",
  "payroll_not_approved": "Kỳ lương chưa được duyệt.",
  "payroll_not_calculated": "Kỳ lương chưa được tính.",
  "payroll_not_published": "Kỳ lương chưa được công bố.",
  "payroll_period_duplicate": "Kỳ lương đã tồn tại.",
  "product_price_unavailable": "Phiên bản sản phẩm chưa có giá đầu vào mà bạn được phép sử dụng.",
  "product_revision_unavailable": "Vui lòng chọn sản phẩm và phiên bản đang hoạt động.",
  "profile_not_approved": "Hồ sơ chưa được duyệt.",
  "profile_not_editable": "Hồ sơ không còn ở trạng thái cho phép sửa.",
  "project_part_required": "Vui lòng chọn phần đề nghị theo dự án.",
  "project_source_mismatch": "Dự án của hóa đơn không khớp với đơn mua hàng nguồn.",
  "project_revision_stale": "Thông tin dự án đã thay đổi. Tải lại trước khi tiếp tục.",
  "purchase_order_lines_required": "Đơn mua hàng phải có ít nhất một dòng chi tiết.",
  "purchase_order_not_deletable": "Đơn mua hàng không còn ở trạng thái cho phép xoá.",
  "purchase_order_not_editable": "Đơn mua hàng không còn ở trạng thái cho phép sửa.",
  "purchase_order_not_found": "Không tìm thấy đơn mua hàng.",
  "purchase_order_not_issued": "Đơn mua hàng chưa được phát hành.",
  "purchase_order_not_receivable": "Đơn mua hàng chưa đủ điều kiện nhận hàng.",
  "purchase_order_overreceipt": "Số lượng nhận vượt số lượng còn lại của đơn mua hàng.",
  "purchase_receipt_material_mismatch": "Vật tư nhận không khớp dòng đơn mua hàng.",
  "purchase_request_immutable": "Không thể thay đổi đề nghị mua hàng liên quan.",
  "purchase_request_lines_required": "Đề nghị mua hàng phải có ít nhất một dòng chi tiết.",
  "purchase_request_not_approved": "Đề nghị mua hàng chưa được duyệt.",
  "purchase_request_not_deletable": "Đề nghị mua hàng không còn ở trạng thái cho phép xoá.",
  "purchase_request_not_editable": "Đề nghị mua hàng không còn ở trạng thái cho phép sửa.",
  "purchase_request_not_found": "Không tìm thấy đề nghị mua hàng.",
  "quotation_already_accepted": "Dự án đã có một báo giá được khách hàng chấp nhận.",
  "quotation_currency_mismatch": "Loại tiền của sản phẩm không khớp báo giá.",
  "quotation_identity_immutable": "Không thể đổi số báo giá hoặc số phiên bản.",
  "quotation_locked": "Báo giá đã phát hành không thể sửa. Vui lòng tạo phiên bản mới.",
  "quote_not_found": "Không tìm thấy báo giá nhà cung cấp.",
  "quote_required": "Vui lòng bổ sung báo giá nhà cung cấp.",
  "receipt_not_supported": "Loại đề nghị này không hỗ trợ xác nhận tiếp nhận.",
  "receipt_separation_required": "Người xác nhận tiếp nhận phải khác người gửi.",
  "recovery_account_hr_independent": "Phải còn đủ tài khoản quản trị khôi phục độc lập với hồ sơ nhân sự.",
  "recovery_role_unbounded_global": "Vai trò khôi phục phải có phạm vi toàn hệ thống không giới hạn thời gian.",
  "replacement_invoice_not_found": "Không tìm thấy hóa đơn cần thay thế.",
  "request_part_missing": "Không tìm thấy phần đề nghị.",
  "request_parts_incomplete": "Các phần đề nghị chưa đầy đủ.",
  "request_type_immutable": "Không thể đổi loại đề nghị.",
  "responsibility_not_owned": "Trách nhiệm này không thuộc tài khoản được chọn.",
  "review_separation_required": "Người duyệt phải khác người tạo hoặc người gửi.",
  "service_unavailable": "Dịch vụ tạm thời không khả dụng. Vui lòng thử lại.",
  "settlement_payment_expected": "Quyết toán này cần ghi nhận khoản chi thêm.",
  "settlement_refund_expected": "Quyết toán này cần ghi nhận khoản hoàn ứng.",
  "source_request_immutable": "Không thể đổi đề nghị gốc.",
  "stock_count_immutable": "Thông tin kiểm kê đã chốt không thể sửa.",
  "stock_count_no_difference": "Kiểm kê không có chênh lệch cần điều chỉnh.",
  "stock_count_stale": "Tồn kho đã thay đổi sau khi kiểm kê. Vui lòng kiểm tra lại.",
  "stock_transaction_not_deletable": "Giao dịch kho không còn ở trạng thái cho phép xoá.",
  "stock_transaction_not_editable": "Giao dịch kho không còn ở trạng thái cho phép sửa.",
  "supplier_invoice_has_payments": "Hóa đơn đã có thanh toán, không thể thực hiện thao tác này.",
  "supplier_invoice_lines_required": "Hóa đơn nhà cung cấp phải có ít nhất một dòng chi tiết.",
  "supplier_invoice_overpaid": "Tổng thanh toán không được vượt tổng tiền hóa đơn; khi sửa hóa đơn phải giữ tổng tiền ít nhất bằng số đã thanh toán.",
  "supplier_invoice_payment_held": "Hóa đơn đang bị giữ thanh toán do chưa khớp đơn hàng hoặc nhận hàng.",
  "supplier_invoice_void": "Hóa đơn nhà cung cấp đã huỷ.",
  "supplier_payment_request_not_paid": "Phiếu chi liên quan chưa được thanh toán.",
  "supplier_payment_request_taken": "Phiếu chi đã được gắn với khoản trả nhà cung cấp khác.",
  "system_role_direct_only": "Vai trò hệ thống phải được gán trực tiếp.",
  "system_role_protected": "Không thể sửa hoặc xoá vai trò hệ thống được bảo vệ.",
  "travel_interval_required": "Vui lòng nhập thời gian công tác.",
  "travel_outside_request": "Thời gian công tác nằm ngoài khoảng đề nghị.",
  "unauthenticated": "Vui lòng đăng nhập để tiếp tục.",
  "vehicle_in_use": "Phương tiện đang được sử dụng, không thể xoá.",
  "workflow_binding_exists": "Đề nghị đã được liên kết với một quy trình phê duyệt.",
  "workflow_binding_mismatch": "Liên kết quy trình không khớp đề nghị.",
  "workflow_binding_missing": "Chưa có liên kết quy trình phê duyệt cho đề nghị.",
  "workflow_group_mismatch": "Nhóm đề nghị không khớp quy trình.",
  "workflow_managed_request": "Đề nghị đang được quản lý bởi quy trình phê duyệt.",
  "workflow_part_mismatch": "Phần đề nghị không khớp quy trình.",
  "workflow_part_revision_mismatch": "Phiên bản phần đề nghị không khớp quy trình.",
  "workflow_recovery_completed": "Thao tác khôi phục quy trình đã hoàn tất.",
  "workflow_revision_gap": "Phiên bản quy trình bị gián đoạn. Vui lòng tải lại và kiểm tra.",
  "workflow_step_regression": "Không thể quay về bước phê duyệt trước đó.",
  "workflow_submit_not_ready": "Quy trình chưa sẵn sàng nhận đề nghị.",
  "workflow_target_mismatch": "Đối tượng của quy trình không khớp đề nghị.",
  "workflow_definition_mismatch": "Quy trình được chọn không khớp cấu hình duyệt của phiếu. Vui lòng kiểm tra cấu hình trước khi gửi lại.",
  "workflow_unavailable": "Dịch vụ phê duyệt tạm thời không khả dụng. Vui lòng thử lại.",
  "department_code_taken": "Mã đơn vị đã được dùng cho đơn vị khác.",
  "department_code_immutable": "Không đổi được mã đơn vị sau khi tạo.",
  "department_cycle": "Không thể đặt đơn vị dưới chính nó hoặc đơn vị con của nó.",
  "department_parent_inactive": "Đơn vị cha đang ngừng dùng.",
  "department_has_children": "Hãy ngừng dùng hoặc chuyển các đơn vị con trước.",
  "department_has_members": "Đơn vị còn nhân viên; hãy chuyển nhân viên sang đơn vị khác trước.",
  "department_not_found": "Phòng ban đã chọn không tồn tại.",
  "department_inactive": "Phòng ban đã chọn đang ngừng dùng.",
  "department_directory_unavailable": "Tạm thời không đọc được danh sách phòng ban. Vui lòng thử lại."
} as const

export type BusinessErrorCode = keyof typeof businessErrorsVi
